import gql from "graphql-tag";

const gqlQuery = gql`
  query Source($sourceId: ID) {
    source(sourceId: $sourceId) {
      use
      type
      brand
      owner
      description
      deploymentNeeds
      currentFirmware
      serial
      model
      scoreboardPerspective
      usuallyDisconnected
      publicInterface {
        adminUrl
        streamTcpUrl
        adminTcpPort
        adminSslPort
        adminTls
        ip
        videoStreamPort
        protocol
        secondCoachUrl
        ptzControllerPort
      }
      ownedByPartnerId
      privateInterface {
        ip
        adminTcpPort
        videoStreamTcpPort
      }
      users {
        admin {
          user
          pass
        }
        viewer {
          user
          pass
        }
      }
    }
  }
`;

export default sourceId => ({
  query: gqlQuery,
  variables: { sourceId },
});
